/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Power: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="power" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M736.6666666666666 1190H623.3333333333333V623.3333333333334H736.6666666666666V1190zM1010.3666666666666 1067.0333333333333L929.8999999999997 986.5666666666666A392.1333333333334 392.1333333333334 0 0 0 1076.6666666666665 680C1076.6666666666665 460.6999999999999 899.3000000000001 283.3333333333335 680 283.3333333333335A396.3833333333334 396.3833333333334 0 0 0 429.5333333333333 987.1333333333334L349.6333333333334 1067.0333333333333A506.1466666666666 506.1466666666666 0 0 1 170 680A510 510 0 0 1 1190 680C1190 835.2666666666667 1120.3 973.5333333333334 1010.3666666666666 1067.0333333333333z" : "M589.3333333333334 952H498.6666666666667V498.6666666666666H589.3333333333334V952zM808.2933333333333 853.6266666666667L743.9199999999998 789.2533333333333A313.7066666666667 313.7066666666667 0 0 0 861.3333333333334 544C861.3333333333334 368.56 719.44 226.6666666666667 544 226.6666666666667A317.1066666666667 317.1066666666667 0 0 0 343.6266666666667 789.7066666666667L279.7066666666667 853.6266666666667A404.9173333333334 404.9173333333334 0 0 1 136 544A408 408 0 0 1 952 544C952 668.2133333333334 896.24 778.8266666666666 808.2933333333333 853.6266666666667z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Power.displayName = `Blueprint5.Icon.Power`;
export default Power;
